import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M15 1C7.266 1 1 7.526 1 15.576c0 1.383.19 2.72.535 3.987.213.781.447 1.556.814 2.257C5.219 27.293 14.999 43 14.999 43s9.781-15.708 12.652-21.18c.367-.701.6-1.476.814-2.257.345-1.268.535-2.604.535-3.987C29 7.526 22.731 1 15 1Zm0 20.995c-1.953 0-3.696-.95-4.825-2.43a6.55 6.55 0 0 1-1.34-3.988c0-3.539 2.766-6.418 6.166-6.418 3.399 0 6.164 2.88 6.164 6.418a6.54 6.54 0 0 1-1.34 3.988c-1.13 1.48-2.872 2.43-4.824 2.43z"
    }, null, -1)
  ])))
}
export default { render: render }